module.exports = __webpack_public_path__ + "img/cherry-turner.4aa66cc9.png";